import files from './files';
import File from '@/models/file';


async function fetch() {
  await files.load();
  let downloads;
  try {
    downloads = (await files.read('support.json')).downloads;
  } catch {
    downloads = [];
  }
  downloads = downloads.map(download => {
    return {
      ...download,
      link: File.query().where('key', download.file).first()?.link
    };
  }).filter(download => download.link);
  return downloads;
}

export default {
  fetch,
};
